<template>
  <div class="invoice-summary">
    <template v-if="isInvoiceValueVisible">
      <span class="invoice-value" :style="statusStyle">
        <RenderMoneyColumnValue
          :value="invoiceValue || 0"
          :max-fraction-digits="0"
        />
        R$
      </span>
      <span v-if="showSeparatorAfterInvoiceValue" class="separator">|</span>
    </template>

    <template v-if="isQtyInvoiceVisible">
      <span class="qty-invoices" :style="statusStyle">
        {{ qtyInvoices }} #
      </span>
      <span v-if="showSeparatorAfterQtyInvoice" class="separator">|</span>
    </template>

    <template v-if="isAverageTicketVisible">
      <span class="average-ticket" :style="statusStyle">
        <RenderMoneyColumnValue
          :value="averageTicket"
          :max-fraction-digits="0"
          :style="statusStyle"
        />
        TM
      </span>
      <span v-if="showSeparatorAfterAverageTicket" class="separator">|</span>
    </template>

    <template v-if="isOverallPercentageVisible">
      <span class="overall-percentage" :style="statusStyle">
        <RenderPercentageColumnValue :value="overallPercentageInvoiceValue" />
        V
      </span>
      <span v-if="showSeparatorAfterOverallPercentage" class="separator"
        >|</span
      >
    </template>

    <template v-if="isSubTotalVisible">
      <span class="subtotal-percentage" :style="statusStyle">
        <RenderPercentageColumnValue :value="subTotalPercentageInvoiceValue" />
        H
      </span>
    </template>
  </div>
</template>

<script>
import {
  RenderMoneyColumnValue,
  RenderPercentageColumnValue,
} from '../../../ui/render';
import { setPanoramaInvoiceStatusColor } from '../utils';

export default {
  name: 'RenderPanoramaSummaryInvoiceLine',
  components: { RenderMoneyColumnValue, RenderPercentageColumnValue },
  props: {
    invoiceValue: {
      type: Number,
      required: true,
    },
    qtyInvoices: {
      type: Number,
      required: true,
    },
    overallPercentageInvoiceValue: {
      type: Number,
      required: true,
    },
    subTotalPercentageInvoiceValue: {
      type: Number,
      required: false,
    },
    status: {
      type: String,
      default: '',
    },
    showInvoiceValue: {
      type: Boolean,
      default: true,
    },
    showQtyInvoice: {
      type: Boolean,
      default: true,
    },
    showOverallPercentage: {
      type: Boolean,
      default: true,
    },
    showSubTotalPercentage: {
      type: Boolean,
      default: true,
    },
    showAverageTicket: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    statusStyle() {
      return this.status ? setPanoramaInvoiceStatusColor(this.status) : {};
    },
    averageTicket() {
      return this.qtyInvoices ? this.invoiceValue / this.qtyInvoices : 0;
    },
    isInvoiceValueVisible() {
      return this.showInvoiceValue;
    },
    isQtyInvoiceVisible() {
      return this.showQtyInvoice;
    },
    isAverageTicketVisible() {
      return this.showAverageTicket;
    },
    isOverallPercentageVisible() {
      return this.showOverallPercentage;
    },
    isSubTotalVisible() {
      return (
        this.subTotalPercentageInvoiceValue !== undefined &&
        this.showSubTotalPercentage
      );
    },
    showSeparatorAfterInvoiceValue() {
      return (
        this.isInvoiceValueVisible &&
        (this.isQtyInvoiceVisible ||
          this.isAverageTicketVisible ||
          this.isOverallPercentageVisible ||
          this.isSubTotalVisible)
      );
    },
    showSeparatorAfterQtyInvoice() {
      return (
        this.isQtyInvoiceVisible &&
        (this.isAverageTicketVisible ||
          this.isOverallPercentageVisible ||
          this.isSubTotalVisible)
      );
    },
    showSeparatorAfterAverageTicket() {
      return (
        this.isAverageTicketVisible &&
        (this.isOverallPercentageVisible || this.isSubTotalVisible)
      );
    },
    showSeparatorAfterOverallPercentage() {
      return this.isOverallPercentageVisible && this.isSubTotalVisible;
    },
  },
};
</script>

<style scoped>
.invoice-summary {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.invoice-value {
  width: 90px;
}

.qty-invoices {
  width: 50px;
}

.average-ticket {
  width: 65px;
}

.overall-percentage {
  width: 50px;
}

.subtotal-percentage {
  width: 50px;
}

.separator {
  padding: 0 5px;
}
</style>
